import React from 'react';
import { AccordionItem } from '../atoms/Accordion';
import cn from 'classnames';

interface ItemProps {
	children: React.ReactNode;
	className?: string;
}

const Item = (props: ItemProps) => {
	const { children, className } = props;
	return (
		<AccordionItem className={cn('border-b-2 border-slate-300', className)}>
			{children}
		</AccordionItem>
	);
};

export default Item;
